import { ThemeCheckType } from '@/hooks/useThemeMode';

export const FOOTER_MODALS_TYPE = {
  CONTINUE: 'CONTINUE',
  PAY_WITH_DISCLAIMER: 'PAY_WITH_DISCLAIMER'
} as const;

export const ButtonType = {
  PREMIUM: 'premium',
  DEFAULT: 'default'
} as const;

export const BUTTON_STYLE_BY_STATUS = {
  DEFAULT_DARK: 'default_dark',
  DEFAULT_LIGHT: 'default_light',
  PREMIUM_DARK: 'premium_dark',
  PREMIUM_LIGHT: 'premium_light'
} as const;

export type ButtonStyle = {
  background: string;
  labelColor: string;
  labelColorTablet?: string;
  labelColorMobile?: string;
};

export type ButtonProps = {
  $isDark: boolean;
  $type?: ButtonType;
  $isLoading?: boolean;
};

export type FOOTER_VARIANT_TYPE = ButtonProps['$type'];

export type ThemeKeyType =
  `${NonNullable<FOOTER_VARIANT_TYPE>}_${ThemeCheckType}`;

export type ButtonType = (typeof ButtonType)[keyof typeof ButtonType];

export type ModalFooterType =
  (typeof FOOTER_MODALS_TYPE)[keyof typeof FOOTER_MODALS_TYPE];

export type FooterModalProps = {
  footerVariant: ModalFooterType;
  onContinue?: () => void;
  onPay?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  isAddBalance?: boolean;
};
